export default class PropertyDetails {
    constructor(){
        this.init()
    }
    init(){
        if(document.querySelector('section.property-detail')){
            let USABounds = new google.maps.LatLngBounds({lat:24.396308, lng:-124.848974}, {lat:49.384358, lng:-66.885444});
            let mapEl = document.getElementById('map');
            let pos = {lat:Number(mapEl.dataset.lat),lng:Number(mapEl.dataset.lng)};
            if([pos.lat, pos.lng].includes(NaN) || !USABounds.contains(pos)) {
                mapEl.parentElement.removeChild(mapEl);
            } else {
                let map = new google.maps.Map(mapEl, {
                    zoom:13,
                    center: pos,
                    styles: [
                        {stylers: [{ hue: "#d2d2d2" }, { saturation: -100 }]},
                        {featureType: "road", elementType: "geometry",
                            stylers: [{ lightness: 100 }, { visibility: "simplified" }]},
                        {featureType: "road", elementType: "labels",
                            stylers: [{ visibility: "on" }]},
                        {featureType: 'poi.business', elementType: 'geometry',
                            stylers: [{ hue: '#ebd3ce' }, { saturation: 32 },
                                { lightness: 10 }, { visibility: 'on' }]}]
                });
                window.marker = new google.maps.Marker({
                    position: pos,
                    icon: {anchor:{x:28.5,y:40},url:'/icons/newmark-map-pin.svg?v=1',scaledSize:{width:57,height:60}},
                    map: map,
                });
            }
        }
    }
    selectImage(el){
        let main = el.parentElement.parentElement.querySelector('.main-photo');
        main.src = el.src;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Property Details.js